import React, { useState } from 'react'
import logo from '../../Assete/Logo.svg'
import { FaAngleRight,FaYoutube,FaTiktok  } from 'react-icons/fa'
import { MdOutlineAddLocation, MdOutlineLocalPhone, MdOutlineMailOutline } from 'react-icons/md'
import { SiMinutemailer } from 'react-icons/si'
import { SlSocialInstagram, SlSocialLinkedin  } from 'react-icons/sl'
import { TiSocialFacebook, TiSocialTwitter } from 'react-icons/ti'
import { Link } from 'react-router-dom'
import { useAuth } from '../../Context/ContextProvider'
function Footer() {
  const { webData } = useAuth()
  console.log(webData);
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }
  const handleSubmit = (e) => {
    e.preventDefault()
    if(email.trim() === ''){
      setError('Email is required')
      return
    }
    if(!isValidEmail(email)){
      setError('Invalid email')
      return
    }
  }
  return (
    <footer className="footer-01 pt-5">
      <div className="container">
        <div className="row">
          <div className="col-md-6 col-lg-4 mb-4 mb-md-0">
            <img src={logo} style={{ width: "240px" }} alt='...' />
            <p>Bridging the gap between potential and possibility.
            We help students and professionals discover the right scholarships, educational pathways and career options that match their skills, interests and ambitions.</p>
            <div className='footer_inp'>
              <input placeholder='Enter E-mail' value={email} onChange={(e) => setEmail(e.target.value)} />
              <button onClick={handleSubmit}>
                <SiMinutemailer />
              </button>
            </div>
            {error && <span className='error-text'>{error}</span>}
          </div>

          <div className="col-md-6 col-lg-4 pl-lg-5  d-flex justify-content-center align-items-lg-center align-items-start flex-column">
            <ul style={{width: "max-content"}} className="list-unstyled p-0">
            <h2 className="footer-heading">Quick Links</h2>
              <li><Link to="/" className="py-1 d-block"> <FaAngleRight className='me-1' />Home</Link></li>
              <li><Link to="/our-mission" className="py-1 d-block"> <FaAngleRight className='me-1' />Our Mission</Link></li>
              <li><Link to="/ask-an-expert" className="py-1 d-block"> <FaAngleRight className='me-1' />Ask an Expert</Link></li>
              <li><Link to="/cv-review" className="py-1 d-block"> <FaAngleRight className='me-1' />CV Review</Link></li>
              <li><Link to="/media-room" className="py-1 d-block"> <FaAngleRight className='me-1' />Media Room</Link></li>
              <li><Link to="/quick-news" className="py-1 d-block"> <FaAngleRight className='me-1' />Latest News</Link></li>
              <li><Link to="/latest-news" className="py-1 d-block"> <FaAngleRight className='me-1' />Recent News Articles</Link></li>
            </ul>
          </div>
          <div className="col-md-6 col-lg-4">
            <h2 className="footer-heading">Have a Questions?</h2>
            <div className="block-23 mb-3">
              <ul className='p-0'>
                <li className='mb-2'><MdOutlineAddLocation className='me-2' /><span className="icon ion-ios-pin" /><span className="text">{webData?.webSettings?.address}</span></li>
                <li className='mb-2'><MdOutlineLocalPhone className='me-2' /><a href="https://wa.me/923120123456"><span className="icon ion-ios-call" /><span className="text">{webData?.webSettings?.contact_number}</span></a></li>
                <li className='mb-2'><MdOutlineMailOutline className='me-2' /><a href="mailto:info@edfura.com"><span className="icon ion-ios-send" /><span className="text">{webData?.webSettings?.email}</span></a></li>
              </ul>
              <div className='footer-social'>
                {webData?.socialMedia?.facebook ? <a href={webData?.socialMedia?.facebook} target='_blank' rel='noopener noreferrer'><TiSocialFacebook /></a> : null}
                {webData?.socialMedia?.twitter ? <a href={webData?.socialMedia?.twitter} target='_blank' rel='noopener noreferrer'><TiSocialTwitter /></a> : null}
                {webData?.socialMedia?.linkedin ? <a href={webData?.socialMedia?.linkedin} target='_blank' rel='noopener noreferrer'><SlSocialLinkedin /></a> : null}
                {webData?.socialMedia?.instagram ? <a href={webData?.socialMedia?.instagram} target='_blank' rel='noopener noreferrer'><SlSocialInstagram /></a> : null}
                {webData?.socialMedia?.youtube ? <a href={webData?.socialMedia?.youtube} target='_blank' rel='noopener noreferrer'><FaYoutube  /></a> : null}
                {webData?.socialMedia?.tiktok ? <a href={webData?.socialMedia?.tiktok} target='_blank' rel='noopener noreferrer'><FaTiktok  /></a> : null}

              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 text-center">
            <p className="copyright">
              Copyright © All rights reserved
            </p>
          </div>
        </div>
      </div>
    </footer>

  )
}

export default Footer